import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { Activity, PermissionRule } from "PFTypes";

export const useCanViewParticipants = () => {
  const isParticipantsVisibilityRestricted = useIsCurrentUserPermittedTo(
    PermissionRule.RestrictActivityParticipantsVisibility
  );

  const canViewParticipants = (activity: Pick<Activity, "coowned">) =>
    !isParticipantsVisibilityRestricted || !!activity.coowned;

  return { canViewParticipants };
};
